<template>
  <div>
    <div
      v-intersect.once
      class="report-graph-area"
      @intersect="onIntersectGraph">
      <template v-for="(dataset, index) in chartData.datasets">
        <div
          :key="index"
          class="checkbox">
          <label>
            <input
              v-model="filteredProviderIds"
              type="checkbox"
              :value="dataset.provider_id"
              @change="onChangeFilterProvider">
            <div class="option-input"></div>
            <div
              :style="`padding: 0px 5px;
                    background-color: ${dataset.backgroundColor};
                    border: 2px solid ${dataset.borderColor};`">
              {{ dataset.label }}
            </div>
          </label>
        </div>
      </template>
      <div class="report-graph-area__content">
        <div class="report-header-description">
          ※各ストア名をクリックすることでグラフを消すことができます。
        </div>
        <div>
          <chart
            :height="graphHeight"
            :chart-data="filteredDataCollection"
            :chart-options="chartOption" />
        </div>
        <div class="report-footer-description">
          ※速報レポートが提供されているストアは上記のみとなります。上記ストア以外は確定レポートでのご確認となります。
        </div>
      </div>
    </div>
    <div class="report-rank-song__heading">
      <ul class="report-rank-song__tab">
        <li
          class="report-rank-song__tab-item"
          :class="{ current: mode === 'release' }">
          <a
            href="#"
            @click.prevent="mode = 'release'">
            リリース
          </a>
        </li>
        <li
          class="report-rank-song__tab-item"
          :class="{ current: mode === 'single' }">
          <a
            href="#"
            @click.prevent="mode = 'single'">
            単  曲
          </a>
        </li>
      </ul>
      <p class="report-date">{{ dateTo }}</p>
    </div>
    <div
      v-intersect.once
      class="report-rank-song-area"
      @intersect="onIntersectRank">
      <div class="report-rank-song-area__column">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="report-rank-song-area__wrap">
          <table class="report-rank-song-area__table">
            <thead class="report-rank-song-area__thead">
              <tr>
                <th>ランキング</th>
                <th
                  :class="{'single-column': mode==='single'}"
                  class="u-text-align-left">
                  アーティスト名
                </th>
                <th
                  :class="{'single-column': mode==='single'}"
                  class="u-text-align-left">
                  リリースタイトル
                </th>
                <th
                  v-if="mode==='single'"
                  :class="{'single-column': mode==='single'}"
                  class="u-text-align-left">
                  楽曲タイトル
                </th>
                <th>リリース種別</th>
                <th v-if="!isSubscription && mode==='release'">アルバム 販売数</th>
                <th v-if="!isSubscription">単曲 販売数</th>
                <th v-if="isSubscription">再生数</th>
              </tr>
            </thead>
            <tbody
              v-if="pagination.data.length > 0"
              class="report-rank-song-area__tbody">
              <tr
                v-for="(item, index) in pagination.data"
                :key="index">
                <td>
                  {{ index + pagination.from }}
                </td>
                <td
                  class="u-text-align-left">
                  {{ item.name }}
                </td>
                <td
                  class="u-text-align-left">
                  {{ item.title || item.title_en }}
                  <span v-if="item.version">({{ item.version }})</span>
                </td>
                <td
                  v-if="mode==='single'"
                  class="u-text-align-left">
                  {{ item.title_ja || item.title_en }}
                  <span v-if="item.track_version">({{ item.track_version }})</span>
                </td>
                <td>{{ item.type === 'album' ? 'アルバム' : 'シングル' }}</td>
                <td v-if="!isSubscription && mode==='release'">{{ item.album_quantity }}</td>
                <td>{{ item.single_quantity }}</td>
              </tr>
            </tbody>
            <tbody
              v-else
              class="report-rank-song-area__tbody">
              <tr>
                <td
                  class="no-data"
                  :class="{ 'disabled-cell': !rankingLoaded }"
                  colspan="10">
                  <div
                    v-if="!rankingLoaded"
                    class="vld-cell">
                    <div class="vld-loading-icon">
                      <vue-loading
                        background-color="#fff"
                        :opacity="0"
                        :active="true"
                        :height="20"
                        :width="20"
                        :is-full-page="false">
                      </vue-loading>
                    </div>
                    <div class="vld-text">
                      読み込み中
                    </div>
                  </div>
                  <span v-else>
                    データはありません。
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="c-btn-wrap c-btn-wrap--with-pager">
          <pagination
            v-if="pagination.last_page > 1"
            :pagination="pagination"
            @on-pagination-clicked="onPaginationClicked">
          </pagination>
          <div
            v-else
            class="pager">
            <ul class="pagination"><li style="visibility:hidden"></li></ul>
          </div>
          <div class="case-number-group">
            <div class="case-number-label">
              <label class="control-label">表示件数</label>
            </div>
            <div class="case-number-item">
              <div class="c-select_wrap">
                <select
                  v-model="perPage"
                  class="c-select">
                  <option :value="5">05</option>
                  <option :value="10">10</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>
            </div>
          </div>
          <a
            href="#"
            class="c-btn c-btn--narrow c-btn--left"
            @click.prevent="downloadCSV">
            CSVダウンロード
            <span class="c-btn__icon-arrow"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { saveAs } from 'file-saver'
import VueLoading from 'vue-loading-overlay'
import Pagination from '../../../components/Pagination'
import Chart from './Chart'

export default {
  name: 'RankingTable',
  components: {
    Chart,
    Pagination,
    VueLoading,
  },
  props: {
    isSubscription: {
      type: Number,
      default: 1,
    },
    summaryType: {
      type: String,
      default: 'daily',
    },
    artists: {
      type: Array,
      default: () => [],
    },
    stores: {
      type: Array,
      default: () => [],
    },
    artistId: {
      type: [String, Number],
      default: null,
    },
    providerIds: {
      type: Array,
      default: () => [],
    },
    ranges: {
      type: Array,
      default: () => [],
    },
    isProviderSummary: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: [String, Number],
      default: null,
    },
    trackId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      mode: 'release',
      reportedDate: null,
      pagination: { data: [] },
      perPage: 5,
      page: 0,
      dateFrom: '',
      dateTo: '',
      filteredProviderIds: [],
      chartData: {},
      chartOption: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: {
            min: 0,
            ticks: {
              precision: 0,
            },
          },
        },
        legend: {
          display: false,
        },
      },
      rankingLoaded: false,
    }
  },
  computed: {
    graphHeight() {
      return window.innerWidth < 895
        ? window.innerWidth * 0.75
        : 170
    },
    filteredDataCollection() {
      if (!this.chartData || !this.chartData.datasets || !this.filteredProviderIds.length === 0) {
        return { datasets: [] }
      }
      const chartData = { ...this.chartData }
      const { filteredProviderIds } = this
      chartData.datasets = chartData.datasets.filter(
        (dataset) => filteredProviderIds.filter(id => id === dataset.provider_id).length > 0,
      )

      return chartData
    },
  },
  watch: {
    mode() {
      this.page = 0
      this.fetchItems()
      this.fetchGraph()
    },
    perPage() {
      this.page = 0
      this.fetchItems()
    },
    summaryType() {
      this.page = 0
      this.fetchItems()
      this.fetchGraph()
    },
    artistId() {
      this.page = 0
      this.fetchItems()
      this.fetchGraph()
    },
    page() {
      this.fetchItems()
    },
    providerIds() {
      this.page = 0
      this.fetchItems()
      this.fetchGraph()
    },
    ranges() {
      this.page = 0
      this.fetchItems()
      this.fetchGraph()
    },
    productId() {
      this.page = 0
      this.chartData = {}
      this.fetchItems()
      this.fetchGraph()
    },
    trackId() {
      this.page = 0
      this.chartData = {}
      this.fetchItems()
      this.fetchGraph()
    },
  },
  mounted() {
    this.reportedDate = moment().format('YYYY年MM月DD日')
  },
  methods: {
    async fetchItems() {
      this.rankingLoaded = false
      this.pagination = { data: [] }
      const headers = { 'content-type': 'multipart/form-data' }
      const { data } = await window.axios.get('/api/client/reports/realtime', {
        params: {
          artist_id: this.artistId,
          is_subscription: this.isSubscription,
          provider_ids: this.filteredProviderIds.filter((id) => id > 0),
          mode: this.mode,
          summary_type: this.summaryType,
          count: this.perPage,
          page: this.page,
          ranges: this.summaryType === 'custom' ? this.ranges : null,
          product_id: this.productId,
          track_id: this.trackId,
        },
        headers,
      })
      this.pagination = data.pagination
      this.dateFrom = moment(data.from).format('MM月DD日')
      this.dateTo = moment(data.to).format('MM月DD日')
      const dateTo = data.to ? `${this.dateFrom}〜${this.dateTo} (最新更新日)` : ''
      this.$emit('latestDate', dateTo)
      this.rankingLoaded = true
    },
    async fetchGraph() {
      const headers = { 'content-type': 'multipart/form-data' }
      const { data } = await window.axios.get(
        this.isProviderSummary ? '/api/client/reports/provider-graph' : '/api/client/reports/graph',
        {
          params: {
            artist_id: this.artistId,
            is_subscription: this.isSubscription,
            provider_ids: this.providerIds,
            mode: this.mode,
            summary_type: this.summaryType,
            ranges: this.summaryType === 'custom' ? this.ranges : null,
            product_id: this.productId,
            track_id: this.trackId,
          },
          headers,
        },
      )
      this.chartData = data
      if (this.filteredProviderIds.length === 0) {
        const providerIds = []
        this.chartData.datasets.forEach((d) => {
          providerIds.push(d.provider_id)
        })
        this.filteredProviderIds = providerIds
      }
    },
    onPaginationClicked(page) {
      this.page = page
    },
    downloadCSV() {
      window.axios.get('/api/client/reports/realtime/download', {
        params: {
          artist_id: this.artistId,
          is_subscription: this.isSubscription,
          provider_ids: this.filteredProviderIds.filter((id) => id > 0),
          mode: this.mode,
          summary_type: this.summaryType,
          ranges: this.summaryType === 'custom' ? this.ranges : null,
          product_id: this.productId,
          track_id: this.trackId,
        },
        responseType: 'blob',
      }).then(response => {
        const blob = new Blob([response.data], {
          type: response.data.type,
        })
        const prefix = this.isSubscription ? 'Streaming' : 'Download'
        const mode = this.mode === 'release' ? 'Release' : 'Single'
        const type = this.summaryType.substr(0, 1).toUpperCase() + this.summaryType.substr(1)
        const date = moment().format('YYYYMMDD')
        const fileName = `${prefix}${mode}-${type}Report-${date}.csv`
        saveAs(blob, fileName)
      })
    },
    onChangeFilterProvider() {
      this.fetchItems()
    },
    onIntersectGraph() {
      this.fetchGraph()
    },
    onIntersectRank() {
      this.fetchItems()
    },
  },
}

</script>

<style scoped>
.chart-area {
  width:1000px!important;
  height:230px!important;
}
.chart-container {
  position: relative;
  margin: auto;
  width:1000px!important;
  height:230px!important;
}
.c-btn-wrap--with-pager {
}

.single-column {
  width: 200px!important;
  padding: 0 15px;
}
.no-data {
  padding: 50px 0 50px;
}

@media screen and (min-width: 896px) {
  .report-header-description {
    font-size: 14px;
    color: #808080;
    text-align: right;
  }
  .report-footer-description {
    font-size: 14px;
    color: #808080;
    text-align: right;
  }
}

@media screen and (max-width: 895px) {
  .report-header-description {
    font-size: 2.6666666667vw;
    margin: 1.3333333333vw 0 1.3333333333vw;
    text-align: right;
  }
  .report-footer-description {
    font-size: 2.6666666667vw;
    margin: 1.3333333333vw 0 1.3333333333vw;
    text-align: right;
  }
}

.vld-overlay {
  position: relative!important;
}
.vld-cell {
  display: flex;
  justify-content: center;
}
.vld-loading-icon {
  display:inline-flex;
}
.vld-text {
  display:inline-flex;
  padding-left: 10px;
}
.disabled-cell {
  background-color: #F9F6F6;
}

</style>
